
// // NOTE selectedid: The currect select date. isMonth and isWeek: wheich text need to disply.
// // Date calulation need to be done here and pass it to parant comp.

import React from 'react';

export interface RangeOption {
  value: number;
  unit: 'week' | 'month' ;
}

interface Props {
  options: RangeOption[];
  selected: RangeOption | null;
  onChange: (option: RangeOption, fromDate: Date) => void;
  getLanguageString?: (option: RangeOption) => string;
}

const getFromDate = (option: RangeOption): Date => {
  const date = new Date();
  if (option.unit === 'month') {
    date.setMonth(date.getMonth() + option.value);
  } else {
    date.setDate(date.getDate() + option.value * 7);
  }
  return date;
};

const DueDateBadge: React.FC<Props> = ({ options, selected, onChange, getLanguageString }) => {
  const baseCls = 'rounded-full border mb-2 mr-2 border-indigo-700 px-3 py-1 cursor-pointer hover:bg-indigo-700 text-center';

  return (
     <div className="flex w-full gap-2">
        {options.map((opt) => {
          const isSelected = selected?.value === opt.value && selected?.unit === opt.unit;
          const label = getLanguageString ? getLanguageString(opt) : `${opt.value} ${opt.unit}${opt.value > 1 ? 's' : ''}`;

          return (
            <div
              key={`${opt.value}-${opt.unit}`}
              onClick={() => onChange(opt, getFromDate(opt))}
              className={`${baseCls}${isSelected ? ' bg-indigo-700' : ''} flex-1 min-w-0 px-3 py-2 text-center rounded-full`}
            >
              <span className="text-neutral-100!">{label}</span>
            </div>
          );
        })}
      </div>
  );
};

export default DueDateBadge;